import React from 'react';
import { GenerateDeedButton } from './GenerateDeedButton';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { useGenerateDocumentMutation } from '../../../../../API/order/documents/DocumentApi';
import { DownloadDeedButton } from './DownloadDeedButton';
import { SectionName } from '../SectionName';
import { eUSAState } from '../../../../../ui-toolkit/enums/states';

export const DeedGenerationSection: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const [generateDocumentMutation, { isLoading: isDocumentGenerating }] = useGenerateDocumentMutation();

  const supportedStates = [eUSAState.AZ, eUSAState.FL, eUSAState.MN, eUSAState.TN];

  if (!data.property.state || !supportedStates.includes(data.property.state as eUSAState)) {
    return null;
  }
  
  return (
    <section className="flex w-full gap-4 pt-12">
      <SectionName>Deed</SectionName>
      <div className={'flex flex-col gap-2'}>
        <DownloadDeedButton isDocumentGenerating={isDocumentGenerating} />
        <GenerateDeedButton
          generateDocumentMutation={generateDocumentMutation}
          isDocumentGenerating={isDocumentGenerating}
        />
      </div>
    </section>
  );
};
